function isObject(value: unknown): value is Record<string, unknown> {
  return Boolean(value) && typeof value === "object" && !Array.isArray(value);
}

export function mergeContent<T>(base: T, overrides: unknown): T {
  if (!isObject(base) || !isObject(overrides)) {
    return (overrides as T) ?? base;
  }

  const next: Record<string, unknown> = { ...base };
  for (const [key, value] of Object.entries(overrides)) {
    const baseValue = (base as Record<string, unknown>)[key];
    if (Array.isArray(value)) {
      next[key] = value;
      continue;
    }
    if (isObject(value) && isObject(baseValue)) {
      next[key] = mergeContent(baseValue, value);
      continue;
    }
    next[key] = value;
  }
  return next as T;
}
